var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"rotate":_vm.rotate,"size":_vm.size,"value":_vm.value,"width":_vm.width,"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }